// extracted by mini-css-extract-plugin
export default {"descriptionWrapper":"AvisoInativarUsuario_descriptionWrapper__uZktu","button":"AvisoInativarUsuario_button__TPzgS","link":"AvisoInativarUsuario_link__+zg70"};